<!--
 * @Author: Junjie
 * @Date: 2024-03-15 17:26:32
 * @LastEditTime: 2024-03-15 17:56:59
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/equipment/account/vue/modules/DeviceControlModal.vue
-->
<template>
  <a-drawer
    :closable="true"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <device-control-form :disabled="disableSubmit" @ok="submitCallback" normal ref="realForm"></device-control-form>
  </a-drawer>
</template>

<script>

  import DeviceControlForm from './DeviceControlForm'

  export default {
    name: 'DeviceControlModal',
    components: {
      DeviceControlForm
    },
    data () {
      return {
        title: "操作",
        width: 700,
        visible: false,
        disableSubmit: true
      }
    },
    methods: {
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>